import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setCurrentZone as setCurrentZoneAction } from '../../redux/cardReader/actions';
import CurrentZone from '../../components/CurrentZone';

class CurrentZoneSelector extends PureComponent {
  render() {
    const { currentZone } = this.props;
    return (
      <CurrentZone
        currentZone={currentZone}
        setCurrentZone={this.props.setCurrentZone}
      />
    );
  }
}

CurrentZoneSelector.propTypes = {
  setCurrentZone: PropTypes.func.isRequired,
  currentZone: PropTypes.string.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentZone: (zone) => dispatch(setCurrentZoneAction(zone)),
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(CurrentZoneSelector);
